import type { Listing } from '../domain/listings';
import { useLoad } from './useLoad';
import { useRepositories } from './useRepositories';

/** The first page of listings I can see in one collection. */
export function useCollectionListings(collectionId: string) {
  const { listings } = useRepositories();
  return useLoad<Listing[]>(
    () => listings.inCollection(collectionId).then((page) => page.items),
    collectionId,
  );
}

/** The newest page of my feed. */
export function useFeed() {
  const { listings } = useRepositories();
  return useLoad<Listing[]>(() => listings.feed().then((page) => page.items), 'feed');
}

export function useListing(id: string) {
  const { listings } = useRepositories();
  return useLoad<Listing>(() => listings.get(id), id);
}
